import { Talent } from "../../Classes";

const tier7 = [
  null,
  new Talent(
    "Bloodthirst",
    "spell_nature_bloodlust",
    [
      "Instantly attacks the target, dealing damage equal to 45% of attack power. In addition, your next 5 melee attacks restore 10 health. Lasts 8 sec.",
    ],
    1,
    [[]],
    [{ x: 4, y: 1 }],
    null,
    "30 Rage",
    "Melee Range",
    "Instant cast",
    "6 sec cooldown",
    null
  ),
  null,
  null,
];

export default tier7;
